import Router from "sap/ui/core/routing/Router";
import { User, UserConfiguration } from "../model/models";
import { EnvironmentService } from "./Environment.service";
import { SettingsService } from "./Settings.service";

export class AuthService {
  private _settingsService: SettingsService;

  constructor() {
    this._settingsService = new SettingsService();
  }

  public static headers?: any;

  public isAuthenticated(): boolean {
    const sExpiry = localStorage.getItem("auth_expiry");
    if (sExpiry) {
      const nExpiry = Date.parse(sExpiry);
      const nNow = new Date().getTime();
      if (nExpiry > nNow) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  public getLoggedInUser(): User | null {
    if (this.isAuthenticated()) {
      return {
        Username: localStorage.getItem("auth_username"),
      };
    } else {
      return null;
    }
  }

  public authenticate(haus: number, username: string, password: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      $.ajax({
        type: "POST",
        url: `${EnvironmentService.getBaseUrl()}/user/token/${haus}`,
        data: JSON.stringify({
          haus: haus,
          username: username,
          password: password,
        }),
        contentType: "application/json",
        crossDomain: true,
        success: (res, status, xhr) => {
          localStorage.setItem("auth_token", res.token);
          localStorage.setItem("auth_expiry", res.expiresAt);
          localStorage.setItem("auth_username", username);

          // configuration
          this._settingsService.setUserConfiguration(res.configuration);

          resolve("OK");
        },
        error: (jqXHR, textStatus, errorThrown) => {
          try {
            resolve(jqXHR.responseJSON.error);
          } catch (ex: any) {
            resolve("Unbekannter Fehler");
          }
        },
      });
    });
  }

  public getUserConfiguration(): UserConfiguration {
    return this._settingsService.getUserConfiguration();
  }

  public logoff(): void {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("auth_expiry");
    localStorage.removeItem("auth_username");
  }

  public static redirectToLogin = (router: Router, name: string, parameters: any) => {
    parameters = { ...parameters, name: name };

    const currentHash = router.getHashChanger().getHash();
    const routeInfo = router.getRouteInfoByHash(currentHash);

    if (routeInfo.name != "login" && routeInfo.name != "loginWithRedirect") {
      if (!name || !name.trim()) {
        router.navTo("login");
      } else {
        router.navTo("loginWithRedirect", { redirect: JSON.stringify(parameters) });
      }
    }
  };
}
